// extracted by mini-css-extract-plugin
export default {"Panel":"WQO7eN7N"};